import { render, staticRenderFns } from "./projectRevokeDialog.vue?vue&type=template&id=3d01da1e&scoped=true"
import script from "./projectRevokeDialog.vue?vue&type=script&lang=js"
export * from "./projectRevokeDialog.vue?vue&type=script&lang=js"
import style0 from "./projectRevokeDialog.vue?vue&type=style&index=0&id=3d01da1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d01da1e",
  null
  
)

export default component.exports